<template>
    <div class="main">
        <div class="wp4">
            <div class="page-tit dffs">
                <router-link class="back-btn" to="/userCenter/newUserIndex"></router-link>
                产业嘉宾名录
            </div>
            <div class="user-tab">
                <!-- Tab 切换逻辑 -->
                <a href="javascript:void(0)" class="tab" :class="{ active: navType === '10' }"
                    @click="changeType('10')">创投嘉宾</a>
                <a href="javascript:void(0)" class="tab" :class="{ active: navType === '13' }"
                    @click="changeType('13')">市场嘉宾</a>
                <!-- 输入框，按回车键查询 -->
                <input v-model="guestAuthKey" class="tb-input" placeholder="关键词（按Enter键查询）" @keyup.enter="getList" />
            </div>
            <div class="table-wrap">
                <table>
                    <thead>
                        <tr>
                            <th>姓名</th>
                            <th>电话号码</th>
                            <th>邮箱</th>
                            <th>公司/机构名称</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- 数据循环展示 -->
                        <tr v-for="(item, index) in guestList" :key="index">
                            <td>{{ item.guestName }}</td>
                            <td>{{ item.talkMobile }}</td>
                            <td>{{ item.talkEmail }}</td>
                            <td>{{ item.company }}</td>
                        </tr>
                        <!-- 当没有数据时的提示 -->
                        <tr v-if="guestList.length == 0">
                            <td class="text-gray" colspan="4">暂无数据</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>


<script>
import { industryApi } from '@/api/industry'

export default {
    data() {
        return {
            // 嘉宾类型选项
            gusetTypeOp: [{
                type: '10',
                name: '创投嘉宾'
            }, {
                type: '13',
                name: '市场嘉宾'
            }],
            // 当前导航类型，默认是 '创投嘉宾'
            navType: '10',
            // 搜索关键词
            guestAuthKey: '',
            // 嘉宾列表数据
            guestList: []
        }
    },
    created() {
        // 初始化加载数据
        this.getList()
    },
    methods: {
        // 获取列表数据
        getList() {
            let params = {
                page: {
                    pageNum: 1,
                    pageSize: 9999
                },
                mainId: this.$session.get("cmm").mainId,
                // 使用当前的导航类型
                guestType: this.navType,
                guestAuthKey: this.guestAuthKey
            }
            // 发起 API 请求
            industryApi.getAuthList(params).then(res => {
                if (res && res.code == 200) {
                    this.guestList = [].concat(res.data.result)
                }
            })
        },
        // 切换 Tab 类型
        changeType(type) {
            this.guestAuthKey = '' // 切换时清空关键词
            this.navType = type    // 更新当前类型
            this.getList()         // 重新获取数据
        },

    }
}
</script>

<style scoped>
.user-tab {
    position: relative;

}

.tb-input {
    padding: 3px 10px;
    width: 200px;
    height: 40px;
    border: 1px solid #C1A17B;
    border-radius: 50px;
    position: absolute;
    top: 50%;
    right: 100px;
    transform: translateY(-50%);
}
</style>
